import { render, staticRenderFns } from "./widget-chart.vue?vue&type=template&id=55d4f789&scoped=true&"
import script from "./widget-chart.vue?vue&type=script&lang=ts&"
export * from "./widget-chart.vue?vue&type=script&lang=ts&"
import style0 from "./widget-chart.vue?vue&type=style&index=0&id=55d4f789&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d4f789",
  null
  
)

export default component.exports